import { useQuery } from "@tanstack/react-query";
import axios from "axios";

import Api from "../Api/Api.json";

const fetchData = async (id) => {
  const headers = { headers: { "Content-Type": "application/json" } };
  const url = Api.DEV_TEST_API;
  const requestData = {
    task: "getPatientWellnessDataForDemo",
    patient_id: id,
  };
  const response = await axios.post(url, requestData, headers);
  console.log("Response from API:", response);
  if (!response.data) {
    throw new Error("Network response was not ok");
  }
  return response.data;
};

export const usePatientWellnessDataForDemo = (id) => {
  // Use React Query to fetch and cache data
  return useQuery({
    queryKey: ["patientWellnessDataForDemo", id], // Unique key for this query
    queryFn: () => fetchData(id), // Function to fetch data
    staleTime: 1000 * 60 * 5, // Data is considered fresh for 5 minutes
    cacheTime: 1000 * 60 * 10, // Cache data for 10 minutes
  });
};
